module.exports = __webpack_public_path__ + "img/cat-empty-pagodeuda.0d7ecc2b.svg";